import { Sprite, Renderer, Texture, Graphics, Matrix } from "pixi.js";
import DebugGraphics from "@/game/libs/engine/util/debug-graphics";

export function convertFrametags(data: AsepriteData) {
  var tags: FrameTag[] = data.meta.frameTags as any;
  var frameTags: any = {};
  tags.forEach(tag => {
    frameTags[tag.name] = tag;
  });
  data.meta.frameTags = frameTags;
  return data;
}

export class Aseprite extends Sprite {
  public data: AsepriteData;
  public animation: string = "";
  constructor(texture: Texture, data: AsepriteData) {
    super(texture.clone());
    this.data = data;
    // this.addChild(this._debug);
  }

  render(renderer: Renderer) {
    this.update(Aseprite.FRAME_DELTA);
    super.render(renderer);
  }

  update(dt: number): void {
    this._elapsed += dt;
    if (this._elapsed >= this._currentFrame().duration) {
      this._elapsed = 0;
      this._currentIndex++;
      if (this._currentIndex + this._currentTag.from > this._currentTag.to) {
        this._currentIndex = 0;
        if (this._onComplete !== null) {
          this._onComplete();
          this._onComplete = null;
        }
      }
      this._update();
    }
  }

  loop(name: string): Aseprite {
    this.animation = name;
    this._currentTag = this.data.meta.frameTags[name] as FrameTag;
    this._currentIndex = 0;
    this._update();

    // this._debug.update(
    //   this.anchor.x,
    //   this.anchor.y,
    //   this._currentFrame().frame.w,
    //   this._currentFrame().frame.h
    // );

    return this;
  }

  play(name: string, onComplete: () => void): Aseprite {
    this._onComplete = onComplete;
    this.animation = name;
    this._currentTag = this.data.meta.frameTags[name] as FrameTag;
    this._currentIndex = 0;
    this._update();

    // this._debug.update(
    //   this.anchor.x,
    //   this.anchor.y,
    //   this._currentFrame().frame.w,
    //   this._currentFrame().frame.h
    // );

    return this;
  }

  centerAnchor(): Aseprite {
    this.anchor.x = 0.5;
    this.anchor.y = 0.5;
    return this;
  }

  _update(): void {
    var rect = this._currentFrame().frame;
    this.texture.frame.x = rect.x;
    this.texture.frame.y = rect.y;
    this.texture.frame.width = rect.w;
    this.texture.frame.height = rect.h;
    this.texture.updateUvs();
  }

  _currentFrame(): Frame {
    var index = this._currentTag.from + this._currentIndex;
    return this.data.frames[index];
  }

  private _currentTag: FrameTag = null as any;
  private _currentIndex: number = 0;
  private _elapsed: number = 0;
  private _onComplete: (() => void) | null = null;
  // private _debug: DebugGraphics = new DebugGraphics(12);
  private static FRAME_DELTA = 16.666666;
}

interface AsepriteData {
  frames: Frame[];
  meta: Meta;
}

interface Meta {
  app: string;
  version: string;
  image: string;
  format: string;
  size: Size;
  scale: string;
  frameTags: Partial<Record<string, FrameTag>>;
  layers: Layer[];
  slices: [];
}

interface Size {
  w: number;
  h: number;
}

interface Rect {
  x: number;
  y: number;
  w: number;
  h: number;
}

interface Frame {
  frame: Rect;
  rotated: boolean;
  trimmed: boolean;
  spriteSourceSize: Rect;
  sourceSize: Size;
  duration: number;
}

interface Layer {
  name: string;
  opacity: number;
  blendMode: string;
}

interface FrameTag {
  name: string;
  from: number;
  to: number;
  direction: string;
}
